<template>
  <div class="status box h-100 d-flex flex-column">
    <header
      class="row align-items-end flex-shrink-0"
      :class="{
        'bg-red': occupied && !rClosed,
        'bg-green': !occupied && !rClosed,
        'bg-dark': rClosed,
      }"
      style="position: relative"
    >
      <img
        v-if="showQRCode"
        :src="resourceQRCode"
        style="
          width: 100px;
          height: 100px;
          position: absolute;
          top: 15px;
          right: 15px;
        "
      />
      <div class="col-12 text-light">
        <h2 v-if="!rClosed">
          {{ occupied ? "Belegt" : "Frei" }}
        </h2>
        <h2 v-if="rClosed">Geschlossen</h2>
        <p v-if="occupied && currentEventTimeRemaining">
          noch {{ currentEventTimeRemaining }}
        </p>
        <p v-if="!occupied && nextEvent && nextEventTimeRemaining">
          nächste Buchung in {{ nextEventTimeRemaining }}
        </p>
      </div>
    </header>
    <main class="flex-grow-1">
      <div v-if="occupied && !rClosed">
        <h3 class="font-weight-bold">{{ currentEvent.title }}</h3>
        <p class="small">{{ currentEvent.customer }}</p>
        <p>{{ currentEvent.comments }}</p>
      </div>
      <div v-if="!occupied && !rClosed">
        <p>Derzeit ist die Ressource durch keine Buchung belegt.</p>
      </div>
      <div v-if="hasError" class="alert alert-danger mt-3">
        Es besteht ein Fehler mit der Verbindung zum Server.
      </div>
      <div v-if="!resourceOpenNow && !hasError" class="alert alert-danger mt-3">
        Öffnungszeiten :
        <ul
          v-if="
            this.info.today_opening_times &&
            this.info.today_opening_times.length
          "
        >
          <li
            v-for="(openingTime, index) in this.info.today_opening_times"
            :key="index"
          >
            {{ openingTime.join(" - ") }}
          </li>
        </ul>
      </div>
      <div v-if="resourceHoliday" class="alert alert-danger mt-3">
        Feiertage / Sperrzeiten : {{ resourceHoliday }}
      </div>
    </main>
    <!--
    <footer>
      <button
      class="btn w-100"
      :class="{ 'btn-red' : occupied, 'btn-green' : !occupied }"
      @click="toggleStatus">
        {{ occupied ? 'Checkout' : 'Checkin' }}
      </button>
    </footer>
    -->
  </div>
</template>

<script>
import { getResourceInfo } from "../utils/api";
import { bookingCache } from "../store/bookingCache";

export default {
  props: {
    resource: String,
  },
  data() {
    return {
      events: [],
      info: [],
      currentDate: new Date(),
      hasError: false,
      showQRCode: Boolean,
    };
  },
  computed: {
    resourceOpenTime() {
      if (this.info.today_opening_times) {
        if (this.info.today_opening_times[0]) {
          return (
            this.info.today_opening_times[0][0] +
            " - " +
            this.info.today_opening_times[0][1]
          );
        }
      }

      return null;
    },
    resourceOpenNow() {
      if (this.info.today_opening_times) {
        for (const timeRange of this.info.today_opening_times) {
          let nowTime =
            String(this.currentDate.getHours()).padStart(2, "0") +
            ":" +
            String(this.currentDate.getMinutes()).padStart(2, "0") +
            ":" +
            String(this.currentDate.getSeconds()).padStart(2, "0");
          if (nowTime <= timeRange[1] && nowTime >= timeRange[0]) {
            return true;
          }
        }
      }

      return false;
    },
    resourceHoliday() {
      if (this.info.today_holidays) {
        // check for closing holiday
        let blockingHoliday = this.info.today_holidays.find(
          (holiday) => holiday.is_closing_time
        );
        if (blockingHoliday) {
          return blockingHoliday.title;
        }
      }

      return null;
    },
    resourceQRCode() {
      if (this.info.qr_code) {
        return this.info.qr_code;
      }

      return null;
    },
    rClosed() {
      if (this.resourceHoliday || !this.resourceOpenNow) {
        return true;
      }

      return false;
    },
    currentEvent() {
    console.log(this.events);
      if (this.events.length) {
        let flagEvent = false;
        for (let i = 0; i < this.events.length; i++) {
          const event = this.events[i];

          if (
            event.startDate <= this.currentDate &&
            event.endDate > this.currentDate
          ) {
            flagEvent = true;
            return event;
            // } else {
            //   return null
          }
        }
        if (!flagEvent) {
          return null;
        }
      }

      return null;
    },
    currentEventTimeRemaining() {
      if (this.currentEvent !== null) {
        let time =
          (this.currentEvent.endDate - this.currentDate) / (1000 * 3600);

        return this.formatTime(time);
      }

      return 0;
    },
    nextEvent() {
      if (this.events.length) {
        for (let i = 0; i < this.events.length; i++) {
          const event = this.events[i];

          if (event.startDate > this.currentDate) {
            return event;
          } else {
            return null;
          }
        }
      }

      return null;
    },
    nextEventTimeRemaining() {
      if (this.nextEvent !== null) {
        let time =
          (this.nextEvent.startDate - this.currentDate) / (1000 * 3600);

        if (time >= 24) {
          return 0;
        }

        return this.formatTime(time);
      }

      return 0;
    },
    occupied() {
      if (this.currentEvent !== null) {
        return true;
      }

      return false;
    },
  },
  created() {
    // Socket listeners removed - using polling interval from App.vue instead
  },
  mounted() {
    this.getResourceStatus();

    this.getStatus();

    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  beforeDestroy() {
    // Cleanup handled by App.vue polling
  },
  methods: {
    updateTime() {
      this.currentDate = new Date();
    },
    toggleStatus() {
      this.occupied = !this.occupied;
    },
    formatTime(time) {
      let hours = Math.floor(time);
      let hoursSuffix = " Stunden";

      if (hours === 1) {
        hoursSuffix = " Stunde";
      }

      let minutes = Math.floor((time % 1) * 60);
      let minutesSuffix = " Minuten";

      if (minutes === 1) {
        minutesSuffix = " Minute";
      }

      let output;

      if (hours > 0) {
        output = hours + hoursSuffix;

        if (minutes > 0) {
          output += " und " + minutes + minutesSuffix;
        }
      } else {
        output = minutes + minutesSuffix;
      }

      return output;
    },
    getResourceStatus() {
      getResourceInfo(this.resource)
        .then((data) => {
          if (data) {
            this.info = data;
          }
          this.hasError = false;
        })
        .catch(() => {
          this.hasError = true;
        });
    },
    async getStatus() {
      try {
        // Only fetch today's events (Calendar component handles other dates)
        await bookingCache.fetchDate(this.resource, this.currentDate);

        // Get all cached events (including today)
        const allEvents = bookingCache.getAll();

        // Filter events from now to end of month
        const dateFrom = new Date(this.currentDate);
        dateFrom.setHours(0, 0, 0, 0);

        const dateTo = new Date(
          this.currentDate.getFullYear(),
          this.currentDate.getMonth() + 1,
          0,
          23,
          59,
          59,
          999
        );

        const dateFromMs = dateFrom.getTime();
        const dateToMs = dateTo.getTime();

        this.events = allEvents.filter((event) => {
          const eventDate =
            event.startDate instanceof Date
              ? event.startDate
              : new Date(event.startDate);

          const eventTime = eventDate.getTime();
          return eventTime >= dateFromMs && eventTime <= dateToMs;
        });

        this.hasError = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error loading status:", error);
        this.hasError = true;
      }
    },
    // Reload status (called by App.vue polling interval)
    reloadStatus() {
      // Clear cache to force fresh fetch
      bookingCache.clear();
      this.getStatus();
      // Also refresh resource info
      this.getResourceStatus();
    },
  },
};
</script>
